import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import {
  joinClassNames,
  promiseSetState,
  promiseSetTimeout,
  isIframeWindow
} from '../../utils/library';
import './modal.css';

class Modal extends Component {
  toggleModal = async (visible) => {
    const { disAbleCloseAnimation } = this.props;
    const setState = promiseSetState(this);
    if (visible) return await setState({ className: 'visible' });
    await setState({ className: disAbleCloseAnimation ? '' : 'fade-out' });
    await promiseSetTimeout(setState, 300, { className: '' });
  };

  constructor(props) {
    super(props);
    this.state = {
      className: props.visible ? 'visible' : ''
    };
    (this.container = document.createElement('div')).className = 'modal';
  }

  componentDidMount() {
    document.body.appendChild(this.container);
    document.addEventListener('keypress', this._handleKeyPressEvent.bind(this));
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.removeChild(this.container);
    document.removeEventListener('keypress', this._handleKeyPressEvent.bind(this));
    document.body.style.overflow = 'visible';
  }

  componentDidUpdate(props) {
    if (props.visible !== this.props.visible) this.toggleModal(this.props.visible);
  }

  _handleKeyPressEvent(event) {
    //only for enter else don't prevent default
    if (event.keyCode === 13) event.preventDefault();
  }

  render() {
    const { isPopup } = this.props;
    const targetContainer = this.container;
    return createPortal(
      // zindex of chatbot icon is 4
      <div
        style={{ zIndex: '5' }}
        className={joinClassNames(
          'animated-container',
          isPopup && 'animated-popup',
          this.props.className,
          this.state.className,
          isIframeWindow() && 'in-iframe'
        )}
      >
        {this.props.children}
      </div>,
      targetContainer
    );
  }
}

Modal.propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
  children: PropTypes.any,
  isPopup: PropTypes.bool,
  disAbleCloseAnimation: PropTypes.any
};

Modal.defaultProps = {
  isPopup: false
};

export default Modal;

export class ModalManager extends Component {
  ModalBuilder = (renderModal, className, isPopup = false, options = {}) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const setState = promiseSetState(this);
      let { modals } = this.state;
      const modal = {
          visible: true,
          onClose: async function (data) {
            modal.visible = false;
            const index = modals.indexOf(modal);
            modals = [...modals];
            await setState({ modals });
            modals.splice(index, 1);
            modals = [...modals];
            await promiseSetTimeout(setState, 500, { modals });
            resolve(data);
          },
          renderComponent: function () {
            return (
              <Modal
                visible={modal.visible}
                isPopup={isPopup}
                {...options}
                key={className}
                className={className}
              >
                {renderModal(modal.onClose)}
              </Modal>
            );
          }
        };
      modals.push(modal);
      await setState({ modals });
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      modals: []
    };
  }

  render() {
    const { modals } = this.state;
    return modals.map(({ renderComponent }) => renderComponent());
  }
}

export const ModalFactory = {
  instance: (
    <ModalManager
      ref={(ref) => {
        ModalFactory.builder = ref && ref.ModalBuilder;
      }}
    />
  ),
  builder: null
};
